import React from 'react';
import {Button} from 'primereact/button'
import {BreadCrumb} from 'primereact/breadcrumb';
import {useLocation, withRouter} from 'react-router-dom';
import {I18n} from "react-redux-i18n";
import {useSelector} from "react-redux";

const AppBreadcrumb = () => {

    const isBusinessProduction = useSelector(state => state.business.isBusinessProduction);
    const isLive = useSelector(state => state.business.current.live);
    const location = useLocation()
    const urls = location.pathname === '/' ? ['home', ''] : location.pathname.split('/');

    let model = []
    for (let i = 0; i < urls.length; i++) {
        let el = urls[i];
        if (el === '') {
            continue;
        }
        model.push({label: I18n.t(el)})
    }

    const home = {icon: 'pi pi-home', url: '/'}

    return (
        <div className="layout-breadcrumb-container p-d-flex p-jc-between p-ai-center p-shadow-1">
            <BreadCrumb model={model} home={home} className="layout-breadcrumb p-pl-4 p-py-2"/>

            {isBusinessProduction === false &&
                <div className=" p-d-flex p-jc-between p-ai-center p-px-4 p-py-2"
                     style={{backgroundColor: '#0a2b4b', color: 'white', borderRadius: '4px', margin: '8px'}}>
                    <div className="p-d-flex p-ai-center">
                        <i className="pi pi-database" style={{marginRight: '0.5rem', fontSize: '1.2rem'}}></i>
                        <span>{I18n.t('SANDBOX_INFO_MESSAGE')}</span>
                    </div>
                </div>}

            {isLive === false &&
                <div className=" p-d-flex p-ai-center p-pr-3">
                    <Button
                        label={I18n.t('SWITCH_TO_PRODUCTION')}
                        className="p-button-sm p-button-rounded p-button-secondary"
                        style={{backgroundColor: '#7a5af8', border: 'none'}}
                    />
                </div>}

            {isLive !== false &&
                <div className="my-4"></div>}

        </div>
    );

}

export default withRouter(AppBreadcrumb);
